<template>
  <div class="article">
    <!--<div class="harder-tabs">
      <div class="tab" :class="{active: classify===''}" @click="tabChange('')"><span>全部</span><span class="line"></span></div>
      <div class="tab" :class="{active: classify===0}" @click="tabChange(0)"><span>推荐</span><span class="line"></span></div>
      <div class="tab" :class="{active: classify===1}" @click="tabChange(1)"><span>好友</span><span class="line"></span></div>
      <div class="tab" :class="{active: classify===2}" @click="tabChange(2)"><span>关注</span><span class="line"></span></div>
      <div class="right-icon" @click="appDownloadTip"></div>
    </div>-->
    <div class="article-list">
      <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="isError"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="getAppEssaysByCondition"
        >
          <article-item v-for="(item, i) in list" :data="item" :key="item.essayNo" @doRefresh="doRefresh" ></article-item>
        </van-list>
      </van-pull-refresh>
    </div>

    <!--<van-popup
        v-model="popupShow"
        round
    >
      <div class="explain">
        <div class="title">云柑号发布须知</div>
        <div class="explain-body">
          <div class="text">目前云柑号文章仅可在PC端云店管家发布</div>
          <div class="text">PC端云店管家网址：</div>
          <div class="link-con">
            <div class="btn" v-clipboard:copy="copyText"
                 v-clipboard:success="onCopySuccess"
                 v-clipboard:error="onCopyError">复制网址</div>
            <div class="link">{{ copyText }}</div>
          </div>
        </div>
      </div>
    </van-popup>-->

    <wx-config v-on:wxConfigReady="wxConfigReady" />

    <get-shop-info :title="'店铺动态'"/>
  </div>
</template>

<script>
  import wxConfig from '@/components/weixin/wxConfig'
  import { getAppEssaysByCondition } from '@/api/publish'
  import ArticleItem from '@/views/Article/components/ArticleItem'
  import GetShopInfo from '@/components/getShopInfo'
  export default {
    components: {
      ArticleItem,
      wxConfig,
      GetShopInfo
    },
    data(){
      return {
        origin: window.location.origin,
        page: 1,
        size: 10,
        list: [],
        classify: '',//0：推荐，1：好友，空为全部
        refreshLoading: false,
        loading: false,
        finished: false,
        isError: false,

        popupShow: false,
        copyText: 'https://antshop.anttalk.vip'
      }
    },
    created(){
      // this.getAppEssaysByCondition()
    },
    methods: {

      tabChange(classify){
        this.page = 1;
        this.size = 10;
        this.list = [];
        this.classify = classify

        this.onRefresh()
      },

      getAppEssaysByCondition(){
        let req = {
          classify: this.classify,//分类
          auditStatus: ['AUDIT_OK'],//审核通过
          shelvesStatus: ['ON_SHELF'],//上架状态
          page: this.page,
          size: this.size,
          mainAccountType: 'SHOP',
          mainAccount: this.$route.query.shopId,
        }
        getAppEssaysByCondition(req).then(res=>{
          let arr = res.data.items || []
          if(arr.length>0){
            if (this.page === 1){
              this.list = [];
            }
            this.list = this.list.concat(arr)
            this.loading = false

            if(res.data.totalPages===this.page){ // 到达最大页
              this.finished = true;
            }
            this.page++
          }else {
            this.loading = false;
            this.finished = true;
          }
        }).catch(() => {
          this.finished = false;
          this.loading = false;
          this.isError = true;
        })
      },

      onRefresh(){
        this.finished = true;
        this.isError = false;
        this.page = 1;
        window.setTimeout(()=>{
          this.finished = false;
          this.list = [];
          this.refreshLoading = false;
          window.scrollTo(0, 0);
        },100)
      },

      doRefresh(data){
        if(this.classify===2){
          this.onRefresh()
        }else {
          this.list = this.list.map(item=>{
            if(data.authorOpenId===item.author.openid){
              item.isFocused = data.flag
            }
            return item
          })
        }
      },

      onCopySuccess(){
        this.$toast('复制成功，请在电脑端打开网址！');
      },
      onCopyError(){
        this.$toast('复制失败！');
      },

      appDownloadTip(){
        this.appDownload({inviteUserId: this.session('userOpenId')});
      },

      // 微信分享
      wxConfigReady(){
        window.setTimeout(()=>{
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          window.wx.updateAppMessageShareData({
            title: this.session('user').nickname + '给你分享了云柑号', // 分享标题
            desc: '云柑号', // 分享描述
            link: this.origin + '/article?inviteUserId=' + (this.session('userOpenId') || this.$route.query.inviteUserId),
            imgUrl: this.origin + '/image/ant-icon.png', // 分享图标
            success: function () {
              // 设置成功
              console.log('article 设置分享朋友成功！')
            }
          });
          // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          window.wx.updateTimelineShareData({
            title: this.session('user').nickname + '给你分享了云柑号', // 分享标题
            link: this.origin + '/article?inviteUserId=' + (this.session('userOpenId') || this.$route.query.inviteUserId),
            imgUrl: this.origin + '/image/ant-icon.png', // 分享图标
            success: function () {
              // 设置成功
              console.log('article 设置分享朋友圈成功！')
            }
          })
        },500)
      },
    }
  }
</script>

<style lang="less" scoped>
  .article{
    position: relative;
    font-size: 15px;
    background-color: #f5f5f5;
    min-height: 100%;
    .harder-tabs{
      position: fixed;top: 0;left: 0;z-index: 1;
      width: 100%;height: 44px;display: flex;
      background-color: #fff;font-size: 14px;
      .tab{
        position: relative;display: inline-flex;
        width: 50px;height: 100%;
        justify-content: center;align-items: center;
        .line{
          position: absolute;z-index: 0;bottom: 4px;left: 20px;
          display: inline-flex;width: 10px;height: 2px;
        }
        &.active{
          color: #1585f3;font-size: 18px;
          .line{background-color: #1585f3;}
        }
      }
      .right-icon{
        display: inline-flex;
        width: 42px;height: 100%;
        position: absolute;z-index: 0;right: 0;top: 0;
        background: url("../../assets/article/top-right-icon.png") no-repeat 50% 50%;
        background-size: 18px;
      }
    }

    .article-list{
      padding: 15px 12px;
      position: absolute;
      top: 0;
      left: 0;bottom: 0;right: 0;overflow-y: auto;
    }
    .explain{
      width: 296px;height: 161px;
      font-size: 14px;
      .title{
        line-height: 1;font-size: 18px;text-align: center;color: #333;padding: 12px 0;
      }
      .explain-body{
        padding: 12px;
        .text{
          color: #333;line-height: 30px;
        }
        .link-con{
          display: flex;height: 28px;
          border: 1px solid #eee;
          border-top-right-radius: 5px;border-bottom-right-radius: 5px;
          .btn{
            display: inline-flex;justify-content: center;align-items: center;
            width: 66px;height: 100%;font-size: 12px;
            background-color: #1585f3;color: #fff;
            border-top-left-radius: 5px;border-bottom-left-radius: 5px;
          }
          .link{
            display: inline-flex;justify-content: flex-start;align-items: center;
            color: #1585f3;padding-left: 12px;
          }
        }
      }
    }
  }
</style>
<style lang="less">
  .article{
    .article-list{
      .van-grid-item__content{padding: 0;}
    }
  }
</style>
